import styled from '@emotion/styled';

export const StyledStickyFooter = styled.div`
    width: 100%;
    background: #ff9600;
    padding: 6px 0;
    overflow: hidden;
    text-align: center;
    position: fixed;
    bottom: 0;
    z-index: 9;

    svg {
        fill: #fff;
    }

    a {
        color: #fff;
        display: inline-flex;
        align-items: center;
        text-decoration: none;
        div {
            margin-left: 10px;
        }
    }
`;
